export function toCapitalize(string: string, isEvery?: boolean): string {
  if (isEvery) {
    return string
      ?.split(' ')
      ?.map((str) => str[0]?.toUpperCase() + str?.slice(1)?.toLowerCase())
      ?.join(' ');
  }
  return string[0]?.toUpperCase() + string?.slice(1)?.toLowerCase();
}
